// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__1r1J7","footer":"footer__1qkaG","tiny":"tiny__1KvyD","clickable":"clickable__iYaus"};